import ClientNotificationResponse from '@/model/response/ClientNotificationResponse'
import { datetime, Schema } from 'simpli-web-sdk'
import * as Helpers from '@/helpers'
import ClientNotificationResponseCSV from '@/model/response/ClientNotificationResponseCSV'

// @ts-ignore
export default (model: ClientNotificationResponseCSV): Schema => ({

    idCargaPk: {
        content: model.idCargaPk,
    },

    nroNotaFiscal: {
        content: Helpers.formatScientificNumber(model.nroNotaFiscal),
    },

    notificacao: {
        content: model.cargaInfo && model.cargaInfo.nomeNotification || '',
    },

    observacaoEntrega: {
        content: model.cargaInfo && model.cargaInfo.observacaoEntrega || '',
    },

    dataCriacao: {
        content: datetime(model.dataCriacao),
        textContent: Helpers.datetimeForCsv(model.dataCriacao),
    },

    nomeDestinatario: {
        content: model.destinatario.nome,
    },

    docDestinatario: {
        content: Helpers.cpfOrCnpj(model.destinatario.cpfCnpj),
    },

    nomeTransportador: {
        content: model.transportador.responsavel.razaoSocial,
    },

    docTransportador: {
        content: Helpers.cnpj(model.transportador.responsavel.cnpj),
    },
})
